import { TDataParser } from "./types";

export const stringParser: TDataParser<string> = (value) => {
  if (!value) return null;

  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  const stringValue = value.toString().trim();
  return stringValue;
};
